import {
  TCsvDatetimeFormatTranslations,
} from './select-csv-datetime-format.ts';

const options: TCsvDatetimeFormatTranslations = {
  iso_8601: 'ISO 8601 / RFC 3339',
  unix_timestamp: 'Znacznik czasu UNIX',
  us: 'NAS',
};

export default {
  placeholder: '',
  label: 'Format daty i godziny',
  options,
};
